import React from "react";
import { Helmet } from "react-helmet";

import Head from "components/Head";
import MainNavigation from "components/Navbars/MainNavigation";
import Hero from "components/Hero";
import MainSection from "components/MainSection";
import ImageSection from "components/ImageSection";
import Background from "components/Background";
import MainFooter from "components/Footers/MainFooter";

import homeHero from "../assets/img/hero-img.png";
import bg_logo from "../assets/img/bg-logo-final.png";

function Home() {
  const menu = [
    { id: 1, label: "Hem", url: "/" },
    { id: 2, label: "Om Oss", url: "/om-sug-och-blas-bil" },
    { id: 3, label: "Kontakta Oss", url: "/kontakta-oss" },
  ];

  const title = "Vakuumsugning. Materialblåsning. Torrsugning. Grävsugning. Spolbil. Rörinspektion.";
  const desc =
    "Vår moderna fordonsflotta, utrustad med kraftfulla sugenheter, kan suga upp både våta och torra material på svåråtkomliga platser. Med sugbilens höga precision kan vi enkelt hantera allt från rensning av brunnar till dränering och underhåll av fastigheter. Sugbilen är särskilt effektiv för borttagning av tunga material där traditionella metoder är opraktiska eller tidskrävande.";

  return (
    <>
      <Head
        pageTitle="Professionell sugbilstjänst för slam och avfall | Sugbil"
        pageDesc="Metabeskrivning: Sugbil erbjuder snabb, effektiv och miljömedveten avfallshantering. Boka våra tjänster idag och få högkvalitativ service! | Sug & Blåsbil Sverige AB"
        link=""
      />
      <Helmet>
        <script type="application/ld+json">
          {`{
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://www.sugbil.nu/",
            "name": "Sug & Blåsbil Sverige AB - Hem",
            "url": "https://www.sugbil.nu/",
            "description": "Sug & Blåsbil Sverige AB erbjuder högkvalitativa tjänster inom avloppsspolning, industriell rengöring och slamsugning i Stockholm och Södertälje.",
            "about": {
              "@id": "https://www.sugbil.nu/#localbusiness"
            }
          },
          {
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "@id": "https://www.sugbil.nu/#localbusiness",
            "name": "Sug & Blåsbil Sverige AB",
            "url": "https://www.sugbil.nu",
            "description": "SUG & BLÅSBIL SVERIGE AB erbjuder tjänster som avloppsspolning, industriell rengöring och slamsugning, skräddarsydda för olika branscher i Stockholm och Södertälje.",
            "logo": "https://www.sugbil.nu/static/media/logo-sugbil.a2d4cc9fc351f40a0a05.png",
            "image": "https://www.sugbil.nu/static/media/hero-img.21aa981cd5fec5481e91.png",
            "email": "info@sugbil.nu",
            "telephone": "+46-8-398810",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Lagerslingan 7",
              "addressLocality": "Södertälje",
              "postalCode": "151 66",
              "addressCountry": "SE"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": "59.1955",
              "longitude": "17.6252"
            },
            "contactPoint": [
              {
                "@type": "ContactPoint",
                "telephone": "+46-8-398810",
                "email": "info@sugbil.nu",
                "contactType": "Customer Service",
                "areaServed": ["Stockholm", "Södertälje"],
                "availableLanguage": ["Swedish", "English"]
              },
              {
                "@type": "ContactPoint",
                "telephone": "+46-76-6399868",
                "contactType": "Mobile Support",
                "availableLanguage": ["Swedish", "English"]
              }
            ],
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                "opens": "08:00",
                "closes": "17:00"
              }
            ],
            "serviceArea": [
              {
                "@type": "AdministrativeArea",
                "name": "Stockholm"
              },
              {
                "@type": "AdministrativeArea",
                "name": "Södertälje"
              }
            ],
            "makesOffer": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Avloppsspolning",
                  "description": "Effektiv rengöring av avlopp och rörsystem."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Industriell Rengöring",
                  "description": "Specialiserad rengöring för industriella anläggningar."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Slamsugning",
                  "description": "Sugning av slam och vatten från olika områden."
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Materialblåsning",
                  "description": "Transport av material till svårtillgängliga områden.",
                  "image": "https://www.sugbil.nu/static/media/IMG_Materialbl%C3%A5sning.64a8e1dc946cb14a3946.png"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Grävsugning",
                  "description": "Friläggning av rör och kablar där grävmaskiner inte når.",
                  "image": "https://www.sugbil.nu/static/media/IMG_Gravsugning.0934529aa68670841a59.png"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Torrsugning",
                  "description": "Effektiv borttagning av torrt material från ytor.",
                  "image": "https://www.sugbil.nu/static/media/IMG_Torrsugning.a65bec800988b78aaef0.png"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Vakuumsugning",
                  "description": "Upphämtning och transport av både våta och torra material.",
                  "image": "https://www.sugbil.nu/static/media/IMG_Vacuumsug.7acd3d283aa1b91a6dda.png"
                }
              }
            ],
            "slogan": "Enkelt. Smart. Snabbt."
          }`}
        </script>
      </Helmet>
      <MainNavigation />
      <Hero
        imageUrl={homeHero}
        showTitle={true}
        imageHeight="85vh"
        heroText={true}
      />
      <Background imgSrc={bg_logo} />
      <MainSection
        showTitle={true}
        title={title}
        showDesc={true}
        description={desc}
        additionalContent={true}
        showSecondRow={true}
        showThirdRow={false}
        showSeparator={false}
      />
      <ImageSection showTitle={false} />
      <MainFooter menuLinks={menu} />
    </>
  );
}

export default Home;
